const abi = [
    "function name() view returns (string)",
    "function symbol() view returns (string)",
    "function balanceOf(address) view returns (uint)",
    "function tokenURI(uint256 tokenId) public view returns (string memory)",
    "function ownerOf(uint256 tokenId) external view returns (address owner)",
    "function tokenOfOwnerByIndex(address owner, uint256 index) public view returns (uint256)",
    "function totalSupply() public view returns (uint256)",
    "function tokenByIndex(uint256 index) public view returns (uint256)",
    "function exists(uint256 tokenId) public view returns (bool)",
    "function claim(string memory name) external",
    "function feed(uint256 tokenId) external",
    "function getParams(uint256 tokenId) public view returns (string memory name, string memory svg, bool isAlive, uint256 life, uint256 age, uint256 timestamp)",
];

export const ContractInfoLocalhost = {
    network: "local",
    networkName: "Hardhat localhost",
    chainId: 31337,
    rpcUrl: "http://localhost:8545",
    address: "0x5FbDB2315678afecb367f032d93F642f64180aa3",
    abi,
};

export const ContractInfoTestnet = {
    network: "testnet",
    networkName: "Polygon Testnet",
    chainId: 80001,
    rpcUrl: "https://rpc-mumbai.maticvigil.com/",
    address: "0xA64934b393daBC4a0EB6f463a18D45681bA906e9", //"0xE7F905B070B6f0907a570457d3b65f5B1c1CD582",
    abi,
};

export const ContractInfoMainnet = {
    network: "mainnet",
    networkName: "Polygon Mainnet",
    chainId: 137,
    rpcUrl: "https://polygon-rpc.com",
    address: "0xd1ee68fbE40967ce3E8afeaA73de8a7BCC825963", //"0xF214Cb677100634FdcD20169f062841Eb3a233e4",
    abi,
};
